import theme_icons from '../../icons.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, RichText, InnerBlocks } = wp.blockEditor;
const { PanelBody, TextControl } = wp.components;

const faqpanel = {
    title: 'Greenheart FAQ Panel',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    parent: ['rbt/faq'],
    //attributes
    attributes: {
        title: {
            type: 'string',
            default: '',
        },
        id: {
            type: 'string',
            default: '',
        },
        icon: {
            type: 'object',
            default: {
                mediaId: 0,
                mediaUrl: '',
                mediaWidth: 0,
                mediaHeight: 0,
                mediaSizes: {},
            },
        },

    },

    edit({ attributes, setAttributes }) {
        const { id, title, icon } = attributes;
        return ([

            <InspectorControls>
                <PanelBody title={__('FAQ Panel Settings')}>
                    <TextControl
                        label={__('(Optional) Panel ID')}
                        value={id}
                        onChange={(newID) => setAttributes({ id: newID.trim().replace(/\s+/g, '-').toLowerCase() })}
                    />
                </PanelBody>
            </InspectorControls>,
            <div className="accordion-wrap" style={{ color: "inherit" }} id={id ? id : null}>
                <h4 className={"accordion-title"} style={{ display: "flex", justifyContent: "space-between", color: "inherit" }}>
                    <span className="left-group">
                        <span className="faq-icon">
                            <MediaUploaderGeneric
                                photo={icon}
                                updateImage={(newIcon) => setAttributes({ icon: newIcon })}
                            />
                        </span>
                        <RichText
                            tagName="span"
                            value={title}
                            onChange={(text) => setAttributes({ title: text })}
                            placeholder="FAQ Title"
                        />
                    </span>
                    <span className="accordion-plus">
                        <svg className="carat-icon" width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 20 L70 50 L30 80 Z" fill="currentColor" />
                        </svg>
                    </span>
                </h4>
                <div className={"accordion-panel"} style={{ color: "inherit" }}>
                    <InnerBlocks />
                </div>

            </div>

        ]);
    },
    save({ attributes }) {
        const { id, title, icon } = attributes;

        return (
            <div className="accordion-wrap" style={{ color: "inherit" }} id={id ? id : null}>
                <h4 className="accordion-title" onclick="accordionClick(event)" style={{ display: "flex", gap: "40px", alignItems: "center", justifyContent: "space-between", color: "inherit" }}>
                    <span className="left-group">
                        {icon.mediaUrl ? <span className="faq-icon">
                            <img
                                src={icon.mediaUrl}
                                alt={title}
                                style={{
                                    objectFit: "contain",
                                    width: "100%",
                                    height: "100%",
                                    maxWidth: "100%",
                                }}
                            />

                        </span> : null}
                        <span>{title}</span>
                    </span>
                    <span className="accordion-plus">
                        <svg className="carat-icon" width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 20 L70 50 L30 80 Z" fill="currentColor" />
                        </svg>
                    </span>
                </h4>
                <div className="accordion-panel"><InnerBlocks.Content /></div>
            </div>
        )
    }
};
registerBlockType('rbt/faqpanel', faqpanel);
export default faqpanel;
